// import { schema } from 'normalizr';
// import { itemSchema } from '../schemas';
import { HOST_TYPE } from '@utils/api-helper/host';
import { summitTypes } from '../constants';

export const fetchContent = (summitKey) => (dispatch) =>
  dispatch({
    endpoint: `summit-details/${summitKey}`,
    type: summitTypes.FETCH_CONTENT,
    method: 'get',
    hostType: HOST_TYPE.CMS
    // schema: new schema.Object({
    //   schedule: new schema.Array(
    //     new schema.Object({
    //       data: new schema.Array(new schema.Object({ item: itemSchema }))
    //     })
    //   )
    // }),
    // schema: {
    //   schedule: new schema.Array({
    //     data: new schema.Array(new schema.Object({ item: itemSchema }))
    //   })
    // },
    // processData(result) {
    //   let data = result.schedule;
    //   if (data?.length > 0) {
    //     data = data.map((daySchedule) => ({
    //       ...daySchedule,
    //       data: daySchedule.data.map((scheduledClass) => ({
    //         item: scheduledClass
    //       }))
    //     }));
    //   }
    //   return {
    //     ...result,
    //     schedule: data
    //   };
    // }
  });

// export const fetchEventsInfo = () => (dispatch) =>
//   dispatch({
//     endpoint: 'v1/uplus/summit/details/',
//     type: summitTypes.FETCH_EVENTS_INFO,
//     method: 'get'
//   });

export const register = (summitUid) => (dispatch) =>
  dispatch({
    endpoint: 'v1/uplus/summit/register/',
    type: summitTypes.REGISTER,
    method: 'post',
    data: {
      summit_uid: summitUid
    }
  });

export const checkIfRegistered = (summitUid) => (dispatch) =>
  dispatch({
    endpoint: `v1/uplus/summit/register/?experience_uid=${summitUid}`,
    type: summitTypes.CHECK_REGISTER,
    method: 'get'
  });

// export const fetchSchedule = (summitUid) => (dispatch) =>
//   dispatch({
//     endpoint: `v1/uplus/summit/schedule?summit_uid=${summitUid}`,
//     type: summitTypes.FETCH_SCHEDULE,
//     method: 'get',
//     schema: new schema.Array(
//       new schema.Object({
//         data: new schema.Array(new schema.Object({ item: itemSchema }))
//       })
//     ),
//     processData(data) {
//       if (data?.length > 0) {
//         return data.map((daySchedule) => ({
//           ...daySchedule,
//           data: daySchedule.data.map((scheduledClass) => ({
//             item: scheduledClass
//           }))
//         }));
//       }
//       return data;
//     }
//   });
